import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import Picture from "/components/core/picture/picture-component";
import { componentStyles } from "./cluster-solutions-component.scss";
class ClusterSolutionsComponent extends PureComponent {
    render() {
        const { showDecorations, cta, selectedCluster } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "cluster-solutions",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-button-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        buttonColor: "brand-blue",
                        ctaText: cta,
                        showDecorations: showDecorations
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "solutions-image-wrapper",
                    children: /*#__PURE__*/ _jsx(Picture, {
                        className: "solutions-image",
                        src: selectedCluster.solutionsImage
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { ClusterSolutionsComponent as default };
